import { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { FiShare2 } from 'react-icons/fi';
import ShareModal from '../modals/share-modal';

const Share = ({ title, description, label }) => {
  const t = useTranslations('common');
  const [open, setOpen] = useState(false);
  const [config, setConfig] = useState({ canonical: '', url: '' });
  const shareDetails = { url: config.url, title, description };

  useEffect(() => {
    const canonical = document.querySelector('link[rel=canonocal]');
    const url = canonical ? canonical.href : document.location.href;
    setConfig({
      canonical,
      url,
    });
  }, []);

  const handleShare = async () => {
    if (navigator.share) {
      try {
        navigator.share(shareDetails);
      } catch (error) {
        console.log(`Oops! I couldn't share to the world because: ${error}`);
      }
    } else {
      setOpen(true);
    }
  };
  return (
    <div className='relative flex items-center justify-center'>
      <button
        className='sharer-button flex items-center justify-center gap-2 max-md:text-sm max-sm:text-xs'
        onClick={handleShare}
      >
        <FiShare2 className='size-6 max-md:size-4' />
        <span className='sharer-button-text'>{label || t('share_key')}</span>
      </button>
      <ShareModal {...{ url: config.url, title, t, open, setOpen }} />
    </div>
  );
};

export default Share;
